import Input from "@/revamp/sections/HomeNewFaq/Input/Input";
import styles from "./CityConnectModalForm.module.scss"
import { useCallback, useEffect, useRef, useState } from "react";
import cn from "clsx";
import {
  SELECT_DEGREE,
  SELECT_PROGRAM,
  degreeOptions,
  errorAccordingToFieldName,
  filterSelectedPrograms,
  getProgramId,
  leadSquareApiCall,
  precedentSelectedPrograms,
  programsOptions,
  regexForInputs,
} from "./utils";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue, ALL_COUNTRIES } from "@/context/utils";
import SubmitButton from "@/components/atoms/FormComponents/SubmitButton";
import { useOTPContext } from "@/components/sections/CommonModals/context";
import Checkbox from "@/components/atoms/FormComponents/Checkbox";
import { trackingDetails } from "@/api/getOtherFormDetails";
import SelectDark from "@/revamp/atoms/FormComponents/Select/SelectDark";
import { DEGREE_TYPES } from "@/components/molecules/ProgramMenu/form-constants";
import {
  formatDate,
  generateUniqueId,
} from "@/components/molecules/Forms/ConnectModalForm/utils";
import CountryDropdownGlobal from "@/revamp/sections/HomeNewFaq/CustomDropdownGlobal/CustomDropdownGlobal";
import { usePathname } from "next/navigation";
import { useIpStackDetails } from "@/helpers/useIpStackDetails";
import customStyles from "@/revamp/atoms/FormComponents/Select/customStyles.module.scss";
import { fetchIpInfoData, getIpJSONData } from "@/context/ip.utils";
import ConsentFormParaIConsent from "@/components/common/utils/consentFormParaIConsent";
import InpSafeForm from "@/components/atoms/FormComponents/InpSafeForm";

const NATIONAL_CODE = "+91";
const CODE = "Code";

const CityConnectModalForm = (props: {
  setMessage?: any;
  isOtpValidated?: (x: any, y?: any) => void;
  setFormResponse?: (x: any) => void;
  gaOtherPayloadInfo?: any;
  setFormValuesData?: (x: any) => void;
  isLandingPage?: boolean;
  associatedPrograms?: Array<ProgramDetails>;
  isNewLeadForm?: boolean;
  checkLeadFail?: (x: boolean) => void;
  isLambdaAPI?: boolean;
  isSpecificPage?: boolean;
  isFaq?: boolean;
  setApplicationRedirectLoaderDisabled?: (x: boolean) => void;
  setAPIResposeURL?: (x: string) => void;
  seatsFilled?: number;
  isSeatsFilled?: boolean;
  isProgramListPage?: boolean;
  isMobile?: boolean;
  landingPageValue?: string;
  isBanner?: boolean;
}) => {
  const {
    setMessage = () => {},
    setFormValuesData = () => {},
    associatedPrograms = [],
    isNewLeadForm = true,
    checkLeadFail = () => {},
    isProgramListPage = false,
    isMobile = false,
    landingPageValue = "",
    isBanner = false,
  } = props;
  const path = usePathname();
  const isAfricaPage = path == "/africa";
  const { ipStackDetails, countryCode } = useIpStackDetails(isAfricaPage);
  const {
    handleSendOTP,
    isOTPLoading,
    setLeadResponse,
    setIsHeaderHidden,
    setShowLoader,
    setIsNewTemplete,
  } = useOTPContext();
  const specializationKey = useRef<string>("");
  const custom10PageTypeKey = useRef<string>("");
  const [programsList, setProgramsList] = useState(programsOptions);
  const [isLoading, loading] = useState(false);
  const isFiredOnceIpinfo = useRef(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [showProgramField, setshowProgramField] = useState(false);
  const apiResponseURL = useRef(null);
  const contactIdRef = useRef(null);
  const [formValues, setFormValues] = useState({
    fullName: "",
    countryCode: NATIONAL_CODE,
    phoneNumber: "",
    emailId: "",
    degree: landingPageValue || SELECT_DEGREE,
    program: "Select Program",
    isTermsAccepted: true,
  });
  const [errors, setErrors] = useState({
    fullName: "",
    countryCode: "",
    phoneNumber: "",
    emailId: "",
    degree: "",
    program: "",
    isTermsAccepted: "",
  });
  const isNational = formValues.countryCode === NATIONAL_CODE;

  useEffect(() => {
    setIsNewTemplete(true);
  }, []);

  useEffect(() => {
    setFormValues((prev) => ({
      ...prev,
      countryCode: countryCode,
    }));
  }, [ipStackDetails]);

  useEffect(() => {
    if (
      (formValues?.fullName ||
        formValues?.emailId ||
        formValues?.phoneNumber) &&
      !isFiredOnceIpinfo.current
    ) {
      setTimeout(fetchIpInfoData, 1000);
      isFiredOnceIpinfo.current = true;
    }
  }, [formValues]);

  const handlePhoneNumberChange = (
    value: string,
    countryCodeVal: string = formValues.countryCode,
  ) => {
    let regexToUse = regexForInputs["phoneNumber"];
    if (countryCodeVal != NATIONAL_CODE) {
      regexToUse = /^[1-9][0-9]{6,14}$/;
    }
    if (!regexToUse.test(value)) {
      setErrors((prev) => ({
        ...prev,
        phoneNumber: errorAccordingToFieldName["phoneNumber"],
      }));
    } else {
      setErrors((prev) => ({ ...prev, phoneNumber: "" }));
    }

    setFormValues((prev) => ({ ...prev, phoneNumber: value }));
  };

  const handleFieldBlur = (fieldName: string, value: string, error: string) => {
    pushToDataLayer({
      event: "form_filled",
      field_name: fieldName,
      option_selected: value || "NA",
      error_message: error || "NA",
      section_name: getGlobalStateValue("parentSection"),
      page_type: "Home Page",
      page_url: window?.location?.href || "NA",
    });
  };

  const handleSingleFieldChange = (
    fieldName: string,
    value: string | boolean,
  ) => {
    let errors = "";
    if (
      (!regexForInputs[fieldName]?.test(value) &&
        fieldName !== "degree" &&
        fieldName !== "program") ||
      value?.toString().includes("Select")
    ) {
      errors = errorAccordingToFieldName[fieldName];
      setErrors((prev) => ({
        ...prev,
        [fieldName]: errorAccordingToFieldName[fieldName],
      }));
    } else {
      setErrors((prev) => ({ ...prev, [fieldName]: "" }));
    }
    setFormValues((prev) => ({ ...prev, [fieldName]: value }));

    if (fieldName === "countryCode") {
      handlePhoneNumberChange(formValues.phoneNumber, value.toString());
    }

    if (fieldName === "degree") {
      setFormValues((prev) => ({ ...prev, program: SELECT_PROGRAM }));
      handleFieldBlur("degree", typeof value === "string" && value, errors);
    }

    if (fieldName === "program") {
      handleFieldBlur("program", typeof value === "string" && value, errors);
    }

    if (fieldName == "program") {
      const selectedProgram = associatedPrograms.find(
        (obj) =>
          obj.attributes.BasicDetails?.Heading?.toLocaleUpperCase() === value,
      );

      if (selectedProgram) {
        specializationKey.current =
          selectedProgram.attributes.BasicDetails?.SpecializationText || "";
        custom10PageTypeKey.current =
          selectedProgram.attributes.BasicDetails?.Custom10PgType || "";
      }
    }
  };

  const leadCheckOnCompletion = async () => {
    try {
      let uniqueId = localStorage.getItem("uniqueLeadId");

      if (!uniqueId) {
        uniqueId = generateUniqueId();
        localStorage.setItem("uniqueLeadId", uniqueId);
      }
      const response = await fetch("/api/leadsquared.com/lead-check", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          PhoneNo: `${formValues.countryCode}-${formValues.phoneNumber}`,
          EmailID: formValues.emailId,
          Name: formValues.fullName,
          CountryCode: formValues.countryCode,
          PageUrl: window.location.href,
          CommConsent: formatDate(new Date()),
          UniqueId: uniqueId,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to submit phone number");
      }
    } catch (error) {
      console.error("Error submitting phone number:", error);
    }
  };

  const checkFieldsValid = () => {
    return (
      formValues.fullName !== "" &&
      formValues.phoneNumber !== "" &&
      formValues.emailId !== "" &&
      formValues.isTermsAccepted &&
      formValues.countryCode !== CODE &&
      Object.values(errors).every((x) => x === "")
    );
  };

  const checkAllFieldsValid = () => {
    return (
      formValues.fullName.trim() !== "" &&
      formValues.phoneNumber.trim() !== "" &&
      formValues.emailId.trim() !== "" &&
      formValues.degree !== "" &&
      formValues.program !== SELECT_PROGRAM &&
      formValues.isTermsAccepted === true &&
      formValues.countryCode !== CODE &&
      Object.values(errors).every((error) => error === "")
    );
  };

  const resetState = () => {
    setIsHeaderHidden(false);
    setshowProgramField(false);
    setFormValues({
      fullName: "",
      countryCode: NATIONAL_CODE,
      phoneNumber: "",
      emailId: "",
      degree: SELECT_DEGREE,
      program: "Select Program",
      isTermsAccepted: true,
    });
  };

  const updateCountryCode = (value) => {
    const newFormValues = { ...formValues };
    newFormValues["countryCode"] = value;
    newFormValues["phoneNumber"] = "";
    setFormValues(newFormValues);
  };

  const handleFormSubmit = (payload) => {
    setFormValuesData(formValues);

    const form = {
      name: payload.fullName,
      phone: payload.phoneNumber,
      countryCode: payload.countryCode,
      email: payload.emailId,
      Custom6: specializationKey.current,
      program: payload.program,
      PROGRAM_ID: getProgramId({
        associatedPrograms,
        program: payload.program,
      }),
      degree: DEGREE_TYPES[payload.degree]?.name,
      consent: true,
      ContactId: contactIdRef.current || "",
    };
    const tracking = trackingDetails();

    const submitCb = () => {
      setIsHeaderHidden(true);
    };

    const verifyCb = () => {
      setShowLoader(false);
      props?.setAPIResposeURL?.(apiResponseURL.current);
      props?.setApplicationRedirectLoaderDisabled?.(false);
      setFormValues({
        fullName: "",
        countryCode: "+" + ipStackDetails?.location?.calling_code || "91",
        phoneNumber: "",
        emailId: "",
        degree: SELECT_DEGREE,
        program: "",
        isTermsAccepted: true,
      });
      props?.isOtpValidated(true);
    };

    const cb = () => {
      return new Promise((resolve, reject) => {
        loading(true);

        // connect-counsellor fires automatically from inside leadSquareApiCall
        // (leadCreateFetch) — see src/utils/connectCounsellor.ts.

        async function performApiCalls() {
          loading(true);
          let leadSquareResponse;
          try {
            const response = await leadSquareApiCall(
              { Custom5: "False", Custom10: custom10PageTypeKey.current || "" },
              form,
              getIpJSONData(),
              tracking,
            );
            if (typeof response === "string") {
              leadSquareResponse = JSON.parse(response);
            } else {
              leadSquareResponse = await response.json();
            }

            if (leadSquareResponse?.success) {
              setIsFormValid(false);
              const resp = leadSquareResponse?.response || {};
              apiResponseURL.current = leadSquareResponse.response.URL || "";

              if (resp?.ContactId) {
                contactIdRef.current = resp.ContactId;
              }

              if (resp.ID === "1" && associatedPrograms.length !== 1) {
                props.isOtpValidated(false);

                setshowProgramField(true);
                return; // Exit here if ID is '1'
              }

              if (props.setFormResponse) {
                props.setFormResponse({
                  ID: resp?.ID,
                  link: resp?.URL,
                  ProspectId: resp?.ProspectId,
                });
              }

              pushToDataLayer({
                event: "lead_submit",
                cta_text: "Get Free Counselling",
                lead_starting_cta:
                  getGlobalStateValue("leadStartingCta") || "Apply Now",
                lead_starting_url: window.location.href || "NA",
                lead_id: resp?.ProspectId || "NA",
                section_name: getGlobalStateValue("parentSection"),
                status: "success",
                error_message: "NA",
                page_type: "Home Page",
                lead_type: resp.ID === "1" ? "lead_submit_1" : "lead_submit_2",
                page_url: window?.location?.href || "NA",
              });
              window?.webengage?.user?.login(resp?.ContactId);

              window?.webengage?.user?.setAttribute("we_email", payload.emailId);
              window?.webengage?.user?.setAttribute(
                "we_first_name",
                payload.fullName,
              );
              window?.webengage?.user?.setAttribute(
                "we_phone",
                payload.countryCode + payload.phoneNumber,
              );

              window?.webengage?.track("Lead Form Filled", {
                "Student Nationality": isNational
                  ? "National"
                  : "International",
                "First Name": payload.fullName,
                "Phone Number": payload.countryCode + payload.phoneNumber,
                "Email ID": payload.emailId,
                "Form Type": "Apply",
                "Section Name": getGlobalStateValue("parentSection"),
                "Application URL": resp?.URL || "",
              });

              if (typeof setLeadResponse === "function") {
                setLeadResponse(
                  showProgramField ? { ...resp, ID: "1" } : resp,
                );
              }
              setIsHeaderHidden(true);
              props.setMessage(
                `Your request for counselling has been sent ${
                  leadSquareResponse?.isDuplicate ? "already" : ""
                }, and our counsellor will reach out to you in the next few hours.`,
              );

              if (payload?.countryCode !== NATIONAL_CODE) {
                verifyCb();
                props?.isOtpValidated(true, resp?.ProspectId);
              }
            } else {
              setShowLoader(false);
              setIsFormValid(false);
              setshowProgramField(true);
              return;
            }
            resolve(leadSquareResponse?.response);
          } catch (error) {
            pushToDataLayer({
              event: "lead_submit",
              cta_text: "Get Free Counselling",
              lead_starting_cta:
                getGlobalStateValue("leadStartingCta") || "Apply Now",
              lead_starting_url: window.location.href || "NA",
              lead_id: "NA",
              section_name: getGlobalStateValue("parentSection"),
              status: "fail",
              error_message: error || "NA",
              page_type: getGlobalStateValue("pageType"),
              lead_type: "lead_submit_1",
              page_url: window?.location?.href || "NA",
            });
            console.error("LeadSquare API call failed:", error);
            setIsFormValid(false);
            setshowProgramField(true);
            setMessage(error);
            reject(error);
            return;
          } finally {
            loading(false);
          }
        }

        performApiCalls();
      });
    };
    handleSendOTP(form, cb, submitCb, verifyCb, checkLeadFail);
  };

  function extractDegree(program) {
    const match = program?.match(/(PG|UG)_Program/);
    return match ? match[1] : null;
  }

  const checkFieldErrors = () => {
    const programDefaultValues: Record<string, any> = {
      degree: SELECT_DEGREE,
      program: SELECT_PROGRAM,
    };

    const programOnlyFields = new Set(["degree", "program"]);

    const fieldsEmpty = Object.keys(formValues).filter((key) => {
      if (!showProgramField && programOnlyFields.has(key)) return false;
      const value = formValues[key];
      return (
        value === "" ||
        (programDefaultValues[key] !== undefined &&
          value === programDefaultValues[key])
      );
    });

    const newErrors = {};
    fieldsEmpty.forEach((key) => {
      newErrors[key] = errorAccordingToFieldName[key];
    });

    setErrors((errors) => ({ ...errors, ...newErrors }));
  };

  const makeFormSubmission = useCallback(
    (e: any) => {
      e.preventDefault();

      checkFieldErrors();
      const valid = checkFieldsValid();
      const isValid = checkAllFieldsValid();

      if (associatedPrograms.length === 1) {
        const programDegree =
          associatedPrograms[0].attributes.BasicDetails.ProgramType;
        const programTitle =
          associatedPrograms[0].attributes.BasicDetails.Heading;
        specializationKey.current =
          associatedPrograms[0].attributes.BasicDetails?.SpecializationText ||
          "";
        custom10PageTypeKey.current =
          associatedPrograms[0].attributes.BasicDetails?.Custom10PgType || "";
        handleSingleFieldChange("degree", extractDegree(programDegree));
        handleSingleFieldChange("program", programTitle);
        const updatedValues = {
          ...formValues,
          degree: extractDegree(programDegree),
          program: programTitle,
        };
        handleFormSubmit(updatedValues);
        return;
      }

      if (isNewLeadForm) {
        if (!showProgramField && valid) {
          handleFormSubmit(formValues);
        } else if (isValid) {
          handleFormSubmit(formValues);
        }
      } else {
        isValid && handleFormSubmit(formValues);
      }
    },
    [formValues, isNewLeadForm, showProgramField],
  );

  useEffect(() => {
    let isValid = false;

    if (formValues.countryCode === "+91") {
      isValid = regexForInputs["phoneNumber"].test(formValues.phoneNumber);
    } else {
      const regexToUse = /^[1-9][0-9]{6,14}$/;
      isValid = regexToUse.test(formValues.phoneNumber);
    }

    if (isValid) {
      const handler = setTimeout(() => {
        leadCheckOnCompletion();
      }, 2000);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [formValues.phoneNumber, formValues.countryCode]);

  useEffect(() => {
    let isValid = false;

    if (regexForInputs["emailId"].test(formValues.emailId)) {
      isValid = true;
    }

    if (isValid) {
      const handler = setTimeout(() => {
        leadCheckOnCompletion();
      }, 2000);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [formValues.emailId]);

  useEffect(() => {
    const newProgramList = filterSelectedPrograms({
      associatedPrograms,
      degree: formValues?.degree,
    });
    setProgramsList(precedentSelectedPrograms(newProgramList));
  }, [formValues?.degree, ipStackDetails]);

  useEffect(() => {
    if (isNewLeadForm) {
      if (!showProgramField) {
        const isFormValid = checkFieldsValid();
        setIsFormValid(isFormValid);
      } else if (showProgramField) {
        const isFormValid = checkAllFieldsValid();
        setIsFormValid(isFormValid);
      }
    } else {
      const isFormValid = checkAllFieldsValid();
      setIsFormValid(isFormValid);
    }
  }, [formValues, setIsFormValid]);

  return (
    <>
      <InpSafeForm
        onSubmit={makeFormSubmission}
        className={cn(styles.root, "lining-nums", )}
      >
        {/* name */}
        <div className={cn(styles.inputWrapper)}>
          <Input
            placeholder="Full Name"
            value={formValues.fullName}
            onChangeFunc={(value: string) =>
              handleSingleFieldChange("fullName", value)
            }
            onBlur={() => handleFieldBlur("fullName", "", errors.fullName)}
            id="full_name"
          />
          <p className={cn(styles.error)}>{errors.fullName}</p>
        </div>
        {/* phone with code */}
        <div className={cn(styles.inputWrapper)}>
          <div className={styles.dropdown}>
            <div>
              <CountryDropdownGlobal
                onChangeFunc={(value: string) =>
                  handleSingleFieldChange("countryCode", value)
                }
                countries={ALL_COUNTRIES}
                countryCode={formValues.countryCode}
                updateCountryCode={updateCountryCode}
                additionalStyle={styles.text_field}
                isDark={false}
                isSpecificPage={props.isSpecificPage}
                disabled={isProgramListPage}
              />
            </div>
            <div className="w-full">
              <Input
                placeholder="Mobile No."
                value={formValues.phoneNumber}
                onChangeFunc={handlePhoneNumberChange}
                onBlur={() =>
                  handleFieldBlur("phoneNumber", "", errors.phoneNumber)
                }
                id="enter_phone_no"
                isTel
              />
            </div>
          </div>
          <p className={cn(styles.error)}>
            {errors.countryCode || errors.phoneNumber}
          </p>
        </div>
        {/* Email */}
        <div className={cn(styles.inputWrapper)}>
          <Input
            placeholder="Email Address"
            value={formValues.emailId}
            onChangeFunc={(value: string) =>
              handleSingleFieldChange("emailId", value)
            }
            onBlur={() => handleFieldBlur("emailId", "", errors.emailId)}
            id="email_id"
          />
          <p className={cn(styles.error)}>{errors.emailId}</p>
        </div>
        {/* Degree */}
        {showProgramField && (
          <div className={cn(styles.inputWrapper)}>
            <SelectDark
              value={formValues.degree}
              onChangeFunc={(value: string) => {
                handleSingleFieldChange("degree", value);
              }}
              options={
                !!landingPageValue
                  ? [landingPageValue]
                  : [SELECT_DEGREE, ...degreeOptions]
              }
              id="degree_lookup"
              customStyles={customStyles}
              isProgramListPage={isProgramListPage}
              disabled={!!landingPageValue}
            />
            <p className={cn(styles.error)}>{errors.degree}</p>
          </div>
        )}
        {/* Program */}
        {showProgramField && (
          <div className={cn(styles.inputWrapper, "w-full")}>
            <SelectDark
              value={formValues.program}
              onChangeFunc={(value: string) => {
                handleSingleFieldChange("program", value);
              }}
              options={["Select Program", ...programsList]}
              id="program_lookup"
              customStyles={customStyles}
              isProgramListPage={isProgramListPage}
            />
            <p className={cn(styles.error)}>{errors.program}</p>
          </div>
        )}
        <div className={styles.commonMargins}>
          <div className="shrink-0">
            <Checkbox
              name="consent"
              value={formValues.isTermsAccepted}
              onChangeFunc={(value: boolean) =>
                handleSingleFieldChange("isTermsAccepted", value)
              }
              onBlur={() =>
                handleFieldBlur("isTermsAccepted", "", errors.isTermsAccepted)
              }
              style={
                isProgramListPage
                  ? {
                      padding: "7px",
                      width: "auto",
                      height: "auto",
                      transform: "none",
                    }
                  : {}
              }
            />
          </div>
          {isProgramListPage ? (
            <ConsentFormParaIConsent
              fontSize={isMobile ? 11 : 14}
              lineHeight={isMobile ? "1rem" : "1.4rem"}
            />
          ) : (
            <p className={styles.authorization}>
              By entering these details I agree that Amity University Online and
              its associates can contact me with updates & notifications via
              Email, SMS, WhatsApp, and Voice call as per its{" "}
              <a
                href="https://amityonline.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "underline",
                  textDecorationColor: "inherit",
                  cursor: "pointer",
                }}
              >
                Privacy Policy
              </a>
              . This consent will override any registration for DNC / NDNC.
            </p>
          )}
          <p className={cn(styles.termserror)}>{errors.isTermsAccepted}</p>
        </div>
        <SubmitButton
          text={isProgramListPage ? "Submit" : "Get Free Counselling"}
          isDisabled={isLoading || isOTPLoading}
        />
      </InpSafeForm>
      {props?.isSeatsFilled ? (
        <div
          className={cn(
            styles.filled_seat_container,
            `${props?.isFaq ? "mt-[1.2rem]" : "mt-5"}`,
          )}
        >
          <div
            className={cn(styles.filled_seats, "w-[72%]")}
            style={
              { "--progress": props?.seatsFilled / 100 } as React.CSSProperties
            }
          >
            <div className={styles.filled}></div>
          </div>
          <div className={cn("w-[40%] lg:w-[21%] text-end", styles.text)}>
            {props?.seatsFilled}% Seats filled
          </div>
        </div>
      ) : null}
      {!isBanner &&  <div className={styles.cards}>
          <div className={styles.card}>
            <p className={styles.bold}>250,000+</p>
            <p>Learner Community</p>
          </div>

          <div className={styles.divider}></div>

          <div className={styles.card}>
            <p className={styles.bold}>100%</p>
            <p>Placement Assistance</p>
          </div>

          <div className={styles.divider}></div>

          <div className={styles.card}>
            <p className={styles.bold}>450+</p>
            <p>Hiring Partners</p>
          </div>
        </div>}
       
    </>
  );
};

export default CityConnectModalForm;
